// import React, { useContext, useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
// import ProductsForm from "../../components/add-product/productsForm";
// import { Button, Grid, List, ListItem } from "@mui/material";
// import FAQ from "../../components/add-product/faq";
// import { UserLoginInfo } from "../../types/context";
// import { appLogger, Http } from "../../utils";
// import { UserContext } from "../../context/userContext";
// import { useLocation, useNavigate } from "react-router-dom";
// import { withSnackbar } from "../../utils/common/SnackbarHoc";
// import HelpIcon from "@mui/icons-material/Help";
// import Tooltip from "@mui/material/Tooltip";

// import {
//   IProductParams,
//   ICategory,
//   FEEDBACK_TYPE_FEEDBACK,
//   FEEDBACK_TYPE_BUGS,
//   FEEDBACK_TYPE_FEATURE_REQ,
//   INVOKE_TYPE_MANUAL,
//   INVOKE_TYPE_AFTER_DELAY,
//   INVOKE_TYPE_CONTEXT_CHANGE,
//   INVOKE_TYPE_IDLE,
//   RATING_ICON_TYPE_STAR,
//   RATING_ICON_TYPE_HEART,
//   RATING_ICON_TYPE_EMOJI,
//   PLATFORM_TYPE_BROWSER,
//   PLATFORM_TYPE_MOBILE, //, EMAIL_MANDATORY, EMAIL_OPTIONAL
//   POS_RIGHT_MIDDLE,
//   TRACKING_SYSTEM_SELF,
//   FEEDBACK_FLOW_STATIC,
//   IFeedbackAgentSettings,
//   IProductInfo,
//   STATUS_PRODUCT_ACTIVE,
//   ITrackingSystem,
//   TRACKING_SYSTEM_JIRA,
//   TRACKING_SYSTEM_ZENDESK,
//   webTechs,
//   IEmailConfiguration,
//   TYPE_NONE,
//   brandingIF,
//   FEEDBACK_FLOW_DYNAMIC,
// } from "../../model";
// import {
//   CompressOutlined,
//   ExpandLess,
//   ExpandMore,
//   StarBorder,
// } from "@mui/icons-material";
// import Preview from "@mui/icons-material/Preview";
// import Joyride, {
//   CallBackProps,
//   STATUS,
//   Step,
//   StoreHelpers,
//   ACTIONS,
// } from "react-joyride";
// //import { setNestedObjectValues } from "formik";
// import ViewComfyIcon from "@mui/icons-material/ViewComfy";
// import { IconWithToolTip } from "../../components/common";
// import images from "../../global-styles/images";
// import { fontWeight, styled } from "@mui/system";
// import { TooltipProps } from "@mui/material";
// import { tooltipClasses } from "@mui/material";
// interface TabPanelProps {
//   children?: any;
//   index: number;
//   value: number;
// }

// const defaultBranding: brandingIF = {
//   "branding-cuvo-popup-dialog-agent-bg": "#f7f8f8",
//   "branding-cuvo-popup-dialog-main-title": "#011348",
//   "branding-cuvo-popup-dialog-main-title-font-family": "Open Sans",
//   "branding-cuvo-popup-dialog-main-title-font-weight": "700",
//   "branding-cuvo-popup-dialog-main-title-font-style": "normal",
//   "branding-cuvo-popup-dialog-main-title-font-size": "34px",
//   "branding-cuvo-popup-dialog-main-subtitle": "#040000",
//   "branding-cuvo-popup-dialog-main-subtitle-font-family": "Open Sans",
//   "branding-cuvo-popup-dialog-main-subtitle-font-weight": "500",
//   "branding-cuvo-popup-dialog-main-subtitle-font-style": "normal",
//   "branding-cuvo-popup-dialog-main-subtitle-font-size": "16px",
//   "branding-cuvo-popup-dialog-card-bg": "#ffffff",
//   "branding-cuvo-popup-dialog-card-title": "#040000",
//   "branding-cuvo-popup-dialog-card-title-font-family": "Open Sans",
//   "branding-cuvo-popup-dialog-card-title-font-weight": "700",
//   "branding-cuvo-popup-dialog-card-title-font-style": "normal",
//   "branding-cuvo-popup-dialog-card-title-font-size": "20px",
//   "branding-cuvo-popup-dialog-card-subtitle": "#040000",
//   "branding-cuvo-popup-dialog-card-subtitle-font-family": "Open Sans",
//   "branding-cuvo-popup-dialog-card-subtitle-font-weight": "500",
//   "branding-cuvo-popup-dialog-card-subtitle-font-style": "normal",
//   "branding-cuvo-popup-dialog-card-subtitle-font-size": "16px",
//   "branding-cuvo-primary-button-bg": "#0157ff",
//   "branding-cuvo-primary-button-text-color": "#ffffff",
//   "branding-cuvo-primary-button-text-font-family": "Open Sans",
//   "branding-cuvo-primary-button-text-font-style": "normal",
//   "branding-cuvo-primary-button-text-font-weight": "400",
//   "branding-cuvo-primary-button-text-font-size": "16px",
//   "branding-cuvo-primary-button-border-color": "#0157ff",
//   "branding-cuvo-secondary-button-bg": "#00000070",
//   "branding-cuvo-secondary-button-text-color": "#ffffff",
//   "branding-cuvo-secondary-button-text-font-family": "Open Sans",
//   "branding-cuvo-secondary-button-text-font-style": "normal",
//   "branding-cuvo-secondary-button-text-font-weight": "400",
//   "branding-cuvo-secondary-button-text-font-size": "16px",
//   "branding-cuvo-secondary-button-border-color": "#00000070",
//   // "branding-cuvo-card-border-color": "#040000",
//   // "branding-cuvo-card-border-radius": "2px",
//   // "branding-cuvo-button-border-radius": "2px",
//   "branding-cuvo-input-label-color": "#040000",
//   "branding-cuvo-input-label-font-family": "Open Sans",
//   "branding-cuvo-input-label-font-style": "normal",
//   "branding-cuvo-input-label-font-weight": "500",
//   "branding-cuvo-input-label-font-size": "16px",
//   "branding-cuvo-input-field-text-color": "#000",
//   "branding-cuvo-input-field-bg-color": "#f4f5f5",
//   "branding-cuvo-attachment-helper-color": "#00000060",
//   "branding-cuvo-attachment-helper-font-family": "Open Sans",
//   "branding-cuvo-attachment-helper-font-style": "normal",
//   "branding-cuvo-attachment-helper-font-weight": "500",
//   "branding-cuvo-attachment-helper-font-size": "16px",
//   "branding-cuvo-card-svg-fg-color": "#0157ff",
//   "branding-cuvo-card-svg-bg-color": "#0157ff1a",
//   "branding-cuvo-selected-star-color": "#ffbc01",
//   "branding-cuvo-unselected-star-color": "#d9d6d6",
//   "branding-cuvo-card-border-color": "#00000070",
//   "branding-cuvo-card-border-radius": "8px",
//   "branding-cuvo-input-border-color": "#00000070",
//   "branding-cuvo-input-border-radius": "8px",
//   "branding-cuvo-comments-field-height": "100px",
//   "branding-cuvo-editor-font-size": "16px",
//   "branding-cuvo-editor-font-family": "Open Sans",
//   "branding-cuvo-primary_btn-border-radius": "4px",
//   "branding-cuvo-secondary_btn-border-radius": "4px",
//   "branding-cuvo-selected-start-rating-uri": "",
//   "branding-cuvo-unselected-start-rating-uri": "",
// };

// const defaultFeedbackAgentSettings: IFeedbackAgentSettings = {
//   //  platform: PLATFORM_TYPE_BROWSER,
//   feedbackTypes: [
//     FEEDBACK_TYPE_FEEDBACK,
//     FEEDBACK_TYPE_BUGS,
//     FEEDBACK_TYPE_FEATURE_REQ,
//   ],
//   showLogo: false,
//   invokeDelay: 5,
//   invokeOn: [INVOKE_TYPE_MANUAL],
//   thanksStr: "Thank You",
//   title: "Cuvo - Customer Voice",
//   subtitle: "Voice your idea or concerns with audio-visual enhancement",
//   uploadFileMaxSize: "400",
//   videoAudioMaxDuration: "1.5",
//   disableDefaultBtn: false,
//   disableCuvo: false,
//   requireEmail: true,
//   captureSystemDetails: true,
//   remoteBtns: [],
//   widgetLookAndFeel: {
//     bgColor: "#042e5b",
//     fgColor: "#ffffff",
//     font: "inherit",
//     fontWeight: 400,
//     fontStyle: "normal",
//     text: "Feedback",
//     icon: "",
//     position: POS_RIGHT_MIDDLE,
//     custom: {
//       top: "",
//       bottom: "",
//       right: "",
//       left: "",
//       borderRadius: "",
//       rotation: "",
//       margin: "",
//       padding: "",
//     },
//   },
//   bugSettings: {
//     categories: [],
//     severities: ["High", "Medium", "Low"],
//     categoryHeading: "Choose the area where you noticed the issue",
//     severityHeading: "Severity of the issue",
//     stdFeedbackHeading: "Choose all options that relate to the issue",
//     generalCommentsHeading: "Describe your issue",
//     attachmentHelp:
//       "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
//     dialogMsg:
//       "Help us understand better with audio/video/screenshot attachment",
//     thanksMsg: "We will attend to your concern.",
//     icon: "",
//     title: "Report an issue",
//     tooltip: "Tell us your concern",
//     reqComments: true,
//     reqDisplayEmail: false,
//     showSeverity: true,
//     reqCategory: false,
//   },
//   feedbackSettings: {
//     type: FEEDBACK_FLOW_STATIC,
//     categories: [],
//     ratingIcon: RATING_ICON_TYPE_STAR,
//     ratingLimit: 3,
//     categoryHeading: "Choose the area related to your feedback",
//     ratingHeading: "How would you rate us",
//     stdFeedbackHeading: "Choose all options that relate to your feedback",
//     generalCommentsHeading: "Anything more you want us to know",
//     attachmentHelp:
//       "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
//     dialogMsg:
//       "Help us understand better with audio/video/screenshot attachment",
//     thanksMsg: "We appreciate your feedback",
//     icon: "",
//     title: "Provide Feedback",
//     tooltip: "Tell us your experience",
//     reqComments: true,
//     reqDisplayEmail: false,
//     reqCategory: false,
//   },
//   featureReqSettings: {
//     categories: [],
//     categoryHeading: "Choose the area related to your request",
//     stdFeedbackHeading: "Choose all options that relate to your request",
//     generalCommentsHeading: "Describe your request",
//     attachmentHelp:
//       "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
//     dialogMsg:
//       "Are there any feature or enhacements that could make your experience better?",
//     thanksMsg: "We appreciate your thoughts and consideration",
//     icon: "",
//     title: "Request a feature",
//     tooltip: "How could we enhance your experience",
//     reqComments: true,
//     reqCategory: false,
//   },
//   bannerType: TYPE_NONE,
//   bannerImage: "",
//   bannerText: "",
//   branding: defaultBranding,
//   qrSettings: {
//     addQR: true,
//     qrHeading: "Scan this QR code with your phone",
//     qrSubHeading:
//       "To provide additional context on your query, please scan the QR code below. You will have an option to submit a screenshot, screen recording or audio recording.",
//   },
// };

// const defaultTrackingSystemSettings: ITrackingSystem = {
//   feedbackTypes: [
//     FEEDBACK_TYPE_FEEDBACK,
//     FEEDBACK_TYPE_BUGS,
//     FEEDBACK_TYPE_FEATURE_REQ,
//   ],
//   configs: {
//     [FEEDBACK_TYPE_BUGS]: {
//       auth: {},
//       type: "SELF",
//     },
//     [FEEDBACK_TYPE_FEATURE_REQ]: {
//       auth: {},
//       type: "SELF",
//     },
//     [FEEDBACK_TYPE_FEEDBACK]: {
//       auth: {},
//       type: "SELF",
//     },
//   },
// };

// const defaultEmailConfig: IEmailConfiguration = {
//   feedbackTypes: [],
//   emailText: {},
//   emailSubject: {
//     [FEEDBACK_TYPE_BUGS]: "Thank you for reporting bug",
//     [FEEDBACK_TYPE_FEATURE_REQ]: "Thank you for providing feature request",
//     [FEEDBACK_TYPE_FEEDBACK]: "Thank you for providing feedback",
//   },
//   emailSalutation: {},
//   emailSignature: {},
//   emailOpeningParagraph: {},
//   emailClosingParagraph: {},
//   ratingLimit: {},
//   severityLimit: {},
// };

// function TabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// function a11yProps(index: number) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

const AddProducts = () =>
  // props: any
  {
    // const navigate = useNavigate();
    // const location: any = useLocation();
    // appLogger.info({
    //   infoObj: {
    //     method: "AddProducts",
    //     component: "add-products",
    //     fileName: "index.tsx",
    //     location: location,
    //   },
    // });
    // const [value, setValue] = useState(0);
    // const [widgetActionValue, setWidgetActionValue] = useState<any>();
    // const {
    //   userInfo,
    //   orgId,
    //   setcontextRedirectProdPage,
    //   setWidgIntgSettingsAccordianContext,
    //   enabledFeatures,
    //   BasicDetailAccordianContext,
    //   setWalkthroughStepIndex,
    //   WalkthroughStepIndex,
    // } = useContext(UserContext) as UserLoginInfo;
    // // const [feedbackAgentSettingsFetched, setFeedbackAgentSettingsFetched] =
    // //   useState(false);
    // const [productParams, setProductParams] = useState<
    //   IProductParams | undefined
    // >();
    // const [isLoading, setIsLoading] = useState(false);
    // const [showHelp, setShowHelp] = useState(false);
    // const [clickedItem, setclickedItem] = useState("");
    // const [errMsg, setErrMsg] = useState({});
    // const [checkConsistency, setCheckConsistency] = useState(true);
    // const [products, setProducts] = React.useState([] as any);
    // const [run, setRun] = useState(false);
    // const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);

    // const items: any = [
    //   {
    //     id: 1,
    //     title: "agentpreview",
    //   },
    //   {
    //     id: 2,
    //     title: "help",
    //   },
    // ];

    // useEffect(() => {
    //   if (location.state != null && location.state.id && location.state.version) {
    //     setIsLoading(true);
    //     Http.get({
    //       url: `/api/v2/products/${location.state.id}/${location.state.version}`,
    //       state: userInfo,
    //     })
    //       .then((response: any) => {
    //         setIsLoading(false);
    //         appLogger.info({
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-products",
    //             fileName: "index.tsx",
    //             productResponse: response,
    //           },
    //         });
    //         response.products[0] = checkAndSetDefaultValues(response.products[0]);
    //         if (location && location.state && location.state.cloneNewProduct) {
    //           response.products[0].id = "";
    //           response.products[0].version = "";
    //           response.products[0].name = "";
    //           response.products[0].apiKey = "";
    //         } else if (
    //           location &&
    //           location.state &&
    //           location.state.cloneNewVersion
    //         ) {
    //           response.products[0].version = "";
    //           response.products[0].apiKey = "";
    //           response.products[0].cloneNewVersion = true;
    //         }
    //         setProductParams(response);

    //         // setFeedbackAgentSettingsFetched(true);
    //       })
    //       .catch((error: any) => {
    //         appLogger.error({
    //           errObj: {
    //             method: "useEffect",
    //             component: "add-products",
    //             fileName: "index.tsx",
    //             err: error,
    //           },
    //         });
    //         // setFailure(true);

    //         props.snackbarShowMessage("products fetch error", "error", 3000);
    //       });
    //   } else {
    //     const newProd = checkAndSetDefaultValues({
    //       id: "",
    //       version: "",
    //       name: "",
    //       status: STATUS_PRODUCT_ACTIVE,
    //       platform: PLATFORM_TYPE_BROWSER,
    //       technology: webTechs[0].value,
    //       orgId:
    //         (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) ||
    //         orgId,
    //     });

    //     appLogger.info({
    //       infoObj: {
    //         method: "useEffect",
    //         component: "add-products",
    //         fileName: "index.tsx",
    //         newProd: newProd,
    //       },
    //     });

    //     setProductParams({ products: [newProd] });
    //   }
    // }, []);

    // useEffect(() => {
    //   if (
    //     productParams &&
    //     productParams.products &&
    //     productParams.products[0] &&
    //     productParams.products[0].id &&
    //     checkConsistency &&
    //     !(location && location.state && location.state.cloneNewVersion)
    //   )
    //     checkProductConfigConsistency();
    // }, [productParams]);

    // function checkProductConfigConsistency() {
    //   if (
    //     productParams &&
    //     productParams.products &&
    //     productParams.products[0] &&
    //     productParams.products[0].id &&
    //     checkConsistency
    //   ) {
    //     if (
    //       basicSettingsMandatoryCheck() &&
    //       generalSettingsMandatoryCheck() &&
    //       feedbackSettingsMandatoryCheck() &&
    //       trackingSystemMandatoryCheck() &&
    //       bugSettingsMandatoryCheck() &&
    //       featureSettingsMandatoryCheck() &&
    //       widgetSettingsMandatoryCheck()
    //     ) {
    //       setCheckConsistency(false);
    //     } else {
    //       props.snackbarShowMessage(
    //         "Some mandatory fields are not set for your product. Please check and fix them.",
    //         "error",
    //         3000
    //       );
    //       setCheckConsistency(false);
    //     }
    //   }
    // }

    // function checkAndSetDefaultValues(product: IProductInfo): IProductInfo {
    //   if (!product.feedbackAgentSettings) {
    //     product.feedbackAgentSettings = defaultFeedbackAgentSettings;
    //   }
    //   if (!product.emailConfig) {
    //     product.emailConfig = defaultEmailConfig;
    //   }
    //   if (!product.trackingSystem) {
    //     product.trackingSystem = defaultTrackingSystemSettings;
    //   }
    //   if (!product.orgId) {
    //     product.orgId =
    //       (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) ||
    //       orgId;
    //   }
    //   if (
    //     product.feedbackAgentSettings &&
    //     !product.feedbackAgentSettings.branding
    //   ) {
    //     product.feedbackAgentSettings.branding = defaultBranding;
    //   }
    //   return product;
    // }

    // function changePtoBrTags(unFormatted: string) {
    //   let formatted = unFormatted;
    //   formatted = formatted.replaceAll("<p>", "<br>").replaceAll("</p>", "");
    //   formatted = formatted.replace("<br>", "");
    //   formatted = "<p>" + formatted + "</p>";
    //   return formatted;
    // }

    // function changeEmailTags(): boolean {
    //   if (
    //     productParams &&
    //     productParams.products &&
    //     productParams.products[0] &&
    //     productParams.products[0].emailConfig
    //   ) {
    //     const temp: IProductParams | undefined = { ...productParams };
    //     if (
    //       productParams.products[0].emailConfig.emailSalutation &&
    //       Object.keys(productParams.products[0].emailConfig.emailSalutation)
    //         .length > 0
    //     ) {
    //       Object.keys(productParams.products[0].emailConfig.emailSalutation).map(
    //         (fdbkType) => {
    //           if (
    //             temp &&
    //             temp.products &&
    //             temp.products[0] &&
    //             temp.products[0].emailConfig &&
    //             temp.products[0].emailConfig.emailSalutation[fdbkType] &&
    //             temp.products[0].emailConfig.emailSalutation[fdbkType].length > 0
    //           ) {
    //             temp.products[0].emailConfig.emailSalutation[fdbkType] =
    //               changePtoBrTags(
    //                 temp.products[0].emailConfig.emailSalutation[fdbkType]
    //               );
    //           }
    //         }
    //       );
    //     }
    //     if (
    //       productParams.products[0].emailConfig.emailOpeningParagraph &&
    //       Object.keys(productParams.products[0].emailConfig.emailOpeningParagraph)
    //         .length > 0
    //     ) {
    //       Object.keys(
    //         productParams.products[0].emailConfig.emailOpeningParagraph
    //       ).map((fdbkType) => {
    //         if (
    //           temp &&
    //           temp.products &&
    //           temp.products[0] &&
    //           temp.products[0].emailConfig &&
    //           temp.products[0].emailConfig.emailOpeningParagraph[fdbkType] &&
    //           temp.products[0].emailConfig.emailOpeningParagraph[fdbkType]
    //             .length > 0
    //         ) {
    //           temp.products[0].emailConfig.emailOpeningParagraph[fdbkType] =
    //             changePtoBrTags(
    //               temp.products[0].emailConfig.emailOpeningParagraph[fdbkType]
    //             );
    //         }
    //       });
    //     }
    //     if (
    //       productParams.products[0].emailConfig.emailText &&
    //       Object.keys(productParams.products[0].emailConfig.emailText).length > 0
    //     ) {
    //       Object.keys(productParams.products[0].emailConfig.emailText).map(
    //         (fdbkType) => {
    //           if (
    //             temp &&
    //             temp.products &&
    //             temp.products[0] &&
    //             temp.products[0].emailConfig &&
    //             temp.products[0].emailConfig.emailText[fdbkType] &&
    //             temp.products[0].emailConfig.emailText[fdbkType].length > 0
    //           ) {
    //             temp.products[0].emailConfig.emailText[fdbkType] =
    //               changePtoBrTags(
    //                 temp.products[0].emailConfig.emailText[fdbkType]
    //               );
    //           }
    //         }
    //       );
    //     }
    //     if (
    //       productParams.products[0].emailConfig.emailClosingParagraph &&
    //       Object.keys(productParams.products[0].emailConfig.emailClosingParagraph)
    //         .length > 0
    //     ) {
    //       Object.keys(
    //         productParams.products[0].emailConfig.emailClosingParagraph
    //       ).map((fdbkType) => {
    //         if (
    //           temp &&
    //           temp.products &&
    //           temp.products[0] &&
    //           temp.products[0].emailConfig &&
    //           temp.products[0].emailConfig.emailClosingParagraph[fdbkType] &&
    //           temp.products[0].emailConfig.emailClosingParagraph[fdbkType]
    //             .length > 0
    //         ) {
    //           temp.products[0].emailConfig.emailClosingParagraph[fdbkType] =
    //             changePtoBrTags(
    //               temp.products[0].emailConfig.emailClosingParagraph[fdbkType]
    //             );
    //         }
    //       });
    //     }
    //     if (
    //       productParams.products[0].emailConfig.emailSignature &&
    //       Object.keys(productParams.products[0].emailConfig.emailSignature)
    //         .length > 0
    //     ) {
    //       Object.keys(productParams.products[0].emailConfig.emailSignature).map(
    //         (fdbkType) => {
    //           if (
    //             temp &&
    //             temp.products &&
    //             temp.products[0] &&
    //             temp.products[0].emailConfig &&
    //             temp.products[0].emailConfig.emailSignature[fdbkType] &&
    //             temp.products[0].emailConfig.emailSignature[fdbkType].length > 0
    //           ) {
    //             temp.products[0].emailConfig.emailSignature[fdbkType] =
    //               changePtoBrTags(
    //                 temp.products[0].emailConfig.emailSignature[fdbkType]
    //               );
    //           }
    //         }
    //       );
    //     }
    //     setProductParams(temp);
    //   }
    //   return true;
    // }

    // function basicSettingsMandatoryCheck(): boolean {
    //   if (
    //     !(
    //       productParams &&
    //       productParams.products &&
    //       productParams.products[0] &&
    //       productParams.products[0].name
    //     )
    //   ) {
    //     props.snackbarShowMessage("You must provide product name", "error", 3000);
    //     const updatedValue = { productNameErr: "You must provide product name" };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }

    //   if (
    //     !(
    //       productParams &&
    //       productParams.products &&
    //       productParams.products[0] &&
    //       productParams.products[0].version
    //     )
    //   ) {
    //     props.snackbarShowMessage(
    //       "You must provide product version",
    //       "error",
    //       3000
    //     );
    //     const updatedValue = {
    //       productVersionErr: "You must provide product version",
    //     };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }

    //   if (
    //     !(
    //       productParams &&
    //       productParams.products &&
    //       productParams.products[0] &&
    //       productParams.products[0].platform
    //     )
    //   ) {
    //     props.snackbarShowMessage(
    //       "You must provide product platform",
    //       "error",
    //       3000
    //     );
    //     const updatedValue = {
    //       productPlatformErr: "You must provide product platform",
    //     };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }
    //   return true;
    // }

    // function generalSettingsMandatoryCheck(): boolean {
    //   if (
    //     !(
    //       productParams &&
    //       productParams.products &&
    //       productParams.products[0] &&
    //       productParams.products[0].feedbackAgentSettings
    //     )
    //   ) {
    //     props.snackbarShowMessage("No data found to save", "error", 3000);
    //     return false;
    //   }

    //   if (productParams.products[0].feedbackAgentSettings.title.length < 1) {
    //     props.snackbarShowMessage(
    //       "You must specify a title or name to display on the widget dialog",
    //       "error",
    //       3000
    //     );
    //     const updatedValue = {
    //       productTitleErr:
    //         "You must specify a title or name to display on the widget dialog",
    //     };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }

    //   if (
    //     productParams.products[0].feedbackAgentSettings.uploadFileMaxSize.length <
    //     1
    //   ) {
    //     props.snackbarShowMessage(
    //       "You must select the maximum allowed size of uploaded file",
    //       "error",
    //       3000
    //     );
    //     const updatedValue = {
    //       uploadFileMaxSizeErr:
    //         "You must select the maximum allowed size of uploaded file",
    //     };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }

    //   if (
    //     productParams.products[0].feedbackAgentSettings.videoAudioMaxDuration
    //       .length < 1
    //   ) {
    //     props.snackbarShowMessage(
    //       "You must select the maximum allowed duration of audio and video recordings",
    //       "error",
    //       3000
    //     );
    //     const updatedValue = {
    //       videoAudioMaxDurationErr:
    //         "You must select the maximum allowed duration of audio and video recordings",
    //     };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }

    //   if (
    //     productParams.products[0].feedbackAgentSettings.feedbackTypes.length < 1
    //   ) {
    //     props.snackbarShowMessage(
    //       "You must choose at least one feedback type",
    //       "error",
    //       3000
    //     );
    //     const updatedValue = {
    //       feedbackTypeErr: "You must choose at least one feedback type",
    //     };
    //     setErrMsg((errMsg) => ({
    //       ...{},
    //       ...updatedValue,
    //     }));
    //     return false;
    //   }
    //   if (productParams.products[0].feedbackAgentSettings.remoteBtns.length > 0) {
    //     const getEmptyVal =
    //       productParams.products[0].feedbackAgentSettings.remoteBtns.filter(
    //         (data: any) => data.btnId == ""
    //       );
    //     if (getEmptyVal.length > 0) {
    //       props.snackbarShowMessage(
    //         "You must specify Remote Button Id",
    //         "error",
    //         3000
    //       );
    //       const updatedValue = {
    //         remoteBtnsEmptyError: "You must specify Remote Button Id",
    //       };
    //       setErrMsg((errMsg) => ({
    //         ...{},
    //         ...updatedValue,
    //       }));
    //       return false;
    //     }
    //   }
    //   const test: any =
    //     productParams.products[0].feedbackAgentSettings.remoteBtns;
    //   if (productParams.products[0].feedbackAgentSettings.remoteBtns.length > 0) {
    //     // const uniqueValues = new Set(test.map((v: any) => v.btnId));
    //     // if (uniqueValues.size < test) {
    //     // }
    //     let hasDuplicate = false;
    //     test
    //       .map((v: any) => v.btnId)
    //       .sort()
    //       .sort((a: any, b: any) => {
    //         if (a === b) hasDuplicate = true;
    //       });
    //     if (hasDuplicate) {
    //       props.snackbarShowMessage(
    //         "You must specify Unique Remote Button Id",
    //         "error",
    //         3000
    //       );
    //       const updatedValue = {
    //         remoteBtnsUniqueBtnIdError:
    //           "You must specify Unique Remote Button Id",
    //       };
    //       setErrMsg((errMsg) => ({
    //         ...{},
    //         ...updatedValue,
    //       }));
    //       return false;
    //     }
    //   }
    //   // return false;
    //   return true;
    // }
    // function stripTags(unStripped: any) {
    //   const parseHTML = new DOMParser().parseFromString(unStripped, "text/html");
    //   return parseHTML.body.textContent || "";
    // }

    // function feedbackSettingsMandatoryCheck(): boolean {
    //   if (productParams) {
    //     if (productParams.products[0].feedbackAgentSettings) {
    //       if (
    //         productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //           FEEDBACK_TYPE_FEEDBACK
    //         ) &&
    //         !productParams.products[0]?.feedbackAgentSettings.feedbackSettings
    //       ) {
    //         props.snackbarShowMessage(
    //           "You must specify feedback settings",
    //           "error",
    //           3000
    //         );
    //         const updatedValue = {
    //           feedbackSettingErr: "You must specify feedback settings",
    //         };
    //         setErrMsg((errMsg) => ({
    //           ...{},
    //           ...updatedValue,
    //         }));
    //         return false;
    //       }

    //       if (productParams.products[0].feedbackAgentSettings.feedbackSettings) {
    //         if (
    //           !productParams.products[0].feedbackAgentSettings.feedbackSettings
    //             .type
    //         ) {
    //           props.snackbarShowMessage(
    //             "You must specify feedback flow type",
    //             "error",
    //             3000
    //           );
    //           const updatedValue = {
    //             feedbackFlowTypeErr: "You must specify feedback flow type",
    //           };
    //           setErrMsg((errMsg) => ({
    //             ...{},
    //             ...updatedValue,
    //           }));
    //           return false;
    //         }
    //       }
    //       if (
    //         productParams.products[0].feedbackAgentSettings.feedbackSettings &&
    //         productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //           FEEDBACK_TYPE_FEEDBACK
    //         )
    //       ) {
    //         if (
    //           productParams &&
    //           productParams.products &&
    //           productParams.products[0] &&
    //           productParams.products[0].emailConfig &&
    //           productParams.products[0].emailConfig.feedbackTypes &&
    //           productParams.products[0].emailConfig.feedbackTypes.includes(
    //             FEEDBACK_TYPE_FEEDBACK
    //           )
    //         ) {
    //           if (
    //             !(
    //               productParams.products[0].emailConfig.emailSubject &&
    //               productParams.products[0].emailConfig.emailSubject[
    //                 FEEDBACK_TYPE_FEEDBACK
    //               ]
    //             )
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must provide email subject for feedback auto reply mail in Email settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               feedbackEmailSubErr: "You must provide email subject",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           if (
    //             !(
    //               productParams.products[0].emailConfig.emailText &&
    //               productParams.products[0].emailConfig.emailText[
    //                 FEEDBACK_TYPE_FEEDBACK
    //               ]
    //             )
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must provide email body for feedback auto reply mail in Email settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               feedbackEmailBodyErr: "You must provide email body",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           if (
    //             productParams.products[0].emailConfig.emailText &&
    //             productParams.products[0].emailConfig.emailText[
    //               FEEDBACK_TYPE_FEEDBACK
    //             ]
    //           ) {
    //             const strippedVal = stripTags(
    //               productParams.products[0].emailConfig.emailText[
    //                 FEEDBACK_TYPE_FEEDBACK
    //               ]
    //             );
    //             if (!strippedVal) {
    //               props.snackbarShowMessage(
    //                 "You must provide email body for feedback auto reply mail in Email settings",
    //                 "error",
    //                 3000
    //               );
    //               const updatedValue = {
    //                 feedbackEmailBodyErr: "You must provide email body",
    //               };
    //               setErrMsg((errMsg) => ({
    //                 ...{},
    //                 ...updatedValue,
    //               }));
    //               return false;
    //             }
    //           }
    //         }
    //         if (
    //           productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //             FEEDBACK_TYPE_FEEDBACK
    //           ) &&
    //           productParams.products[0].feedbackAgentSettings.feedbackSettings
    //             .categories.length > 0
    //         ) {
    //           const modifyCategories = [];
    //           let flag = false;
    //           const categories =
    //             productParams.products[0].feedbackAgentSettings.feedbackSettings
    //               .categories;
    //           for (const category of categories) {
    //             if (
    //               category["name"] == "" &&
    //               category["feedbacks"] &&
    //               category["feedbacks"]?.length != 0
    //             ) {
    //               flag = true;
    //             } else if (
    //               category["name"] == "" &&
    //               category["feedbacks"] &&
    //               category["feedbacks"]?.length == 0
    //             ) {
    //             } else {
    //               modifyCategories.push(category);
    //             }
    //           }
    //           if (flag) {
    //             props.snackbarShowMessage(
    //               "You must specify the category name for the feedback in feedback settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               feedbackCategoryErr:
    //                 "You must specify the category name for the feedback in feedback settings",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           productParams.products[0].feedbackAgentSettings.feedbackSettings.categories =
    //             modifyCategories;
    //         }
    //         if (
    //           productParams.products[0].feedbackAgentSettings.feedbackSettings
    //             .categories.length < 1 &&
    //           (productParams.products[0].feedbackAgentSettings.feedbackSettings
    //             .type === FEEDBACK_FLOW_DYNAMIC ||
    //             productParams.products[0].feedbackAgentSettings.feedbackSettings
    //               .reqCategory)
    //         ) {
    //           props.snackbarShowMessage(
    //             "You must specify at least one category in feedback settings",
    //             "error",
    //             3000
    //           );
    //           const updatedValue = {
    //             feedbackCategoryErr:
    //               "You must specify at least one category in feedback settings",
    //           };
    //           setErrMsg((errMsg) => ({
    //             ...{},
    //             ...updatedValue,
    //           }));
    //           return false;
    //         }
    //         return true;
    //       }
    //     }
    //   }
    //   return true;
    // }

    // function bugSettingsMandatoryCheck(): boolean {
    //   if (productParams) {
    //     if (productParams.products[0].feedbackAgentSettings) {
    //       if (
    //         productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //           FEEDBACK_TYPE_BUGS
    //         ) &&
    //         !productParams.products[0].feedbackAgentSettings.bugSettings
    //       ) {
    //         props.snackbarShowMessage(
    //           "You must specify ticket settings",
    //           "error",
    //           3000
    //         );
    //         const updatedValue = {
    //           bugSettingErr: "You must specify bug settings",
    //         };
    //         setErrMsg((errMsg) => ({
    //           ...{},
    //           ...updatedValue,
    //         }));
    //         return false;
    //       }

    //       if (
    //         productParams.products[0].feedbackAgentSettings.bugSettings &&
    //         productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //           FEEDBACK_TYPE_BUGS
    //         )
    //       ) {
    //         if (
    //           productParams &&
    //           productParams.products &&
    //           productParams.products[0] &&
    //           productParams.products[0].emailConfig &&
    //           productParams.products[0].emailConfig.feedbackTypes &&
    //           productParams.products[0].emailConfig.feedbackTypes.includes(
    //             FEEDBACK_TYPE_BUGS
    //           )
    //         ) {
    //           if (
    //             !(
    //               productParams.products[0].emailConfig &&
    //               productParams.products[0].emailConfig.emailSubject &&
    //               productParams.products[0].emailConfig.emailSubject[
    //                 FEEDBACK_TYPE_BUGS
    //               ]
    //             )
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must provide email subject for ticket auto reply mail in Email settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               bugEmailSubErr: "You must provide email subject",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           if (
    //             !(
    //               productParams.products[0].emailConfig.emailText &&
    //               productParams.products[0].emailConfig.emailText[
    //                 FEEDBACK_TYPE_BUGS
    //               ]
    //             )
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must provide email body for bug auto reply mail in Email settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               bugEmailBodyErr: "You must provide email body",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           if (
    //             productParams.products[0].emailConfig.emailText &&
    //             productParams.products[0].emailConfig.emailText[
    //               FEEDBACK_TYPE_BUGS
    //             ]
    //           ) {
    //             const strippedVal = stripTags(
    //               productParams.products[0].emailConfig.emailText[
    //                 FEEDBACK_TYPE_BUGS
    //               ]
    //             );
    //             if (!strippedVal) {
    //               props.snackbarShowMessage(
    //                 "You must provide email body for bug auto reply mail in Email settings",
    //                 "error",
    //                 3000
    //               );
    //               const updatedValue = {
    //                 bugEmailBodyErr: "You must provide email body",
    //               };
    //               setErrMsg((errMsg) => ({
    //                 ...{},
    //                 ...updatedValue,
    //               }));
    //               return false;
    //             }
    //           }
    //         }
    //         if (
    //           productParams.products[0].feedbackAgentSettings.bugSettings
    //             .categories.length > 0
    //         ) {
    //           const modifyCategories = [];
    //           let flag = false;
    //           const categories =
    //             productParams.products[0].feedbackAgentSettings.bugSettings
    //               .categories;
    //           for (const category of categories) {
    //             if (
    //               category["name"] == "" &&
    //               category["feedbacks"] &&
    //               category["feedbacks"]?.length != 0
    //             ) {
    //               flag = true;
    //             } else if (
    //               category["name"] == "" &&
    //               category["feedbacks"] &&
    //               category["feedbacks"]?.length == 0
    //             ) {
    //             } else {
    //               modifyCategories.push(category);
    //             }
    //           }
    //           if (flag) {
    //             props.snackbarShowMessage(
    //               "You must specify the category name for the feedback in bug settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               bugCategoryErr:
    //                 "You must specify the category name for the feedback in bug settings",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           productParams.products[0].feedbackAgentSettings.bugSettings.categories =
    //             modifyCategories;
    //         }
    //         if (
    //           productParams.products[0].feedbackAgentSettings.bugSettings
    //             .categories.length < 1 &&
    //           productParams.products[0].feedbackAgentSettings.bugSettings
    //             .reqCategory
    //         ) {
    //           props.snackbarShowMessage(
    //             "You must specify at least one category in ticket settings",
    //             "error",
    //             3000
    //           );
    //           const updatedValue = {
    //             bugCategoryErr:
    //               "You must specify at least one category in ticket settings",
    //           };
    //           setErrMsg((errMsg) => ({
    //             ...{},
    //             ...updatedValue,
    //           }));
    //           return false;
    //         }

    //         if (
    //           productParams.products[0].feedbackAgentSettings.bugSettings
    //             .severities.length > 0
    //         ) {
    //           const modifySeverity: string[] = [];
    //           const severities =
    //             productParams.products[0].feedbackAgentSettings.bugSettings
    //               .severities;
    //           severities.filter((e) => {
    //             if (e != "") {
    //               modifySeverity.push(e);
    //             }
    //           });
    //           productParams.products[0].feedbackAgentSettings.bugSettings.severities =
    //             modifySeverity;
    //           if (
    //             modifySeverity.length < 1 &&
    //             productParams.products[0].feedbackAgentSettings.bugSettings
    //               .showSeverity
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must specify at least one severity in bug settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               bugSeverityErr:
    //                 "You must specify at least one severity in bug settings",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //         }

    //         if (
    //           productParams.products[0].feedbackAgentSettings.bugSettings
    //             ?.severities.length < 1 &&
    //           productParams.products[0].feedbackAgentSettings.bugSettings
    //             ?.showSeverity
    //         ) {
    //           props.snackbarShowMessage(
    //             "You must specify at least one severity in bug settings",
    //             "error",
    //             3000
    //           );
    //           const updatedValue = {
    //             bugSeverityErr:
    //               "You must specify at least one severity in bug settings",
    //           };
    //           setErrMsg((errMsg) => ({
    //             ...{},
    //             ...updatedValue,
    //           }));
    //           return false;
    //         }
    //       }

    //       if (productParams.products[0].trackingSystem) {
    //         if (
    //           productParams.products[0].trackingSystem &&
    //           productParams.products[0].trackingSystem.feedbackTypes
    //         ) {
    //           if (
    //             productParams.products[0].trackingSystem &&
    //             productParams.products[0].trackingSystem.feedbackTypes.includes(
    //               FEEDBACK_TYPE_BUGS
    //             )
    //           ) {
    //             if (
    //               productParams.products[0].trackingSystem &&
    //               productParams.products[0].trackingSystem.configs &&
    //               productParams.products[0].trackingSystem &&
    //               productParams.products[0].trackingSystem.configs[
    //                 FEEDBACK_TYPE_BUGS
    //               ]
    //             ) {
    //               if (
    //                 productParams.products[0].trackingSystem &&
    //                 productParams.products[0].trackingSystem.configs &&
    //                 productParams.products[0].trackingSystem &&
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_BUGS
    //                 ].isToolConnected
    //               ) {
    //                 if (
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].type === TRACKING_SYSTEM_JIRA &&
    //                   !productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].project
    //                 ) {
    //                   props.snackbarShowMessage(
    //                     "You must select one project type in External Tracking System Bugs settings",
    //                     "error",
    //                     3000
    //                   );
    //                   const updatedValue = {
    //                     BUGS: {
    //                       extProjectTypeErr:
    //                         "You must select one project type in External Tracking System Bugs settings",
    //                     },
    //                   };
    //                   setErrMsg((errMsg) => ({
    //                     ...{},
    //                     ...updatedValue,
    //                   }));
    //                   return false;
    //                 }
    //                 if (
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].type === TRACKING_SYSTEM_ZENDESK &&
    //                   !productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].tags
    //                 ) {
    //                   props.snackbarShowMessage(
    //                     "You must select one tag type in External Tracking System Bugs settings",
    //                     "error",
    //                     3000
    //                   );
    //                   const updatedValue = {
    //                     BUGS: {
    //                       extProjectTypeErr:
    //                         "You must select one tag type in External Tracking System Bugs settings",
    //                     },
    //                   };
    //                   setErrMsg((errMsg) => ({
    //                     ...{},
    //                     ...updatedValue,
    //                   }));
    //                   return false;
    //                 }

    //                 if (
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].type === TRACKING_SYSTEM_JIRA &&
    //                   !(
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs &&
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs[
    //                       FEEDBACK_TYPE_BUGS
    //                     ].issueType
    //                   )
    //                 ) {
    //                   props.snackbarShowMessage(
    //                     "You must select one issue type in External Tracking System Bugs settings",
    //                     "error",
    //                     3000
    //                   );
    //                   const updatedValue = {
    //                     BUGS: {
    //                       extIssueTypeErr:
    //                         "You must select one issue type in External Tracking System Bugs settings",
    //                     },
    //                   };
    //                   setErrMsg((errMsg) => ({
    //                     ...{},
    //                     ...updatedValue,
    //                   }));
    //                   return false;
    //                 }
    //                 if (
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].type === TRACKING_SYSTEM_ZENDESK &&
    //                   !(
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs &&
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs[
    //                       FEEDBACK_TYPE_BUGS
    //                     ].ticketType
    //                   )
    //                 ) {
    //                   props.snackbarShowMessage(
    //                     "You must select one ticket type in External Tracking System Bugs settings",
    //                     "error",
    //                     3000
    //                   );
    //                   const updatedValue = {
    //                     BUGS: {
    //                       extIssueTypeErr:
    //                         "You must select one ticket type in External Tracking System Bugs settings",
    //                     },
    //                   };
    //                   setErrMsg((errMsg) => ({
    //                     ...{},
    //                     ...updatedValue,
    //                   }));
    //                   return false;
    //                 }
    //                 if (
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].type === TRACKING_SYSTEM_JIRA &&
    //                   !(
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs &&
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs[
    //                       FEEDBACK_TYPE_BUGS
    //                     ].defaultSeverity
    //                   )
    //                 ) {
    //                   props.snackbarShowMessage(
    //                     "You must select one default Severity type in External Tracking System Bugs settings",
    //                     "error",
    //                     3000
    //                   );
    //                   const updatedValue = {
    //                     BUGS: {
    //                       extDefaultSevErr:
    //                         "You must select one default Severity type in External Tracking System Bugs settings",
    //                     },
    //                   };
    //                   setErrMsg((errMsg) => ({
    //                     ...{},
    //                     ...updatedValue,
    //                   }));
    //                   return false;
    //                 }
    //                 if (
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_BUGS
    //                   ].type === TRACKING_SYSTEM_ZENDESK &&
    //                   !(
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs &&
    //                     productParams.products[0].trackingSystem &&
    //                     productParams.products[0].trackingSystem.configs[
    //                       FEEDBACK_TYPE_BUGS
    //                     ].defaultSeverity
    //                   )
    //                 ) {
    //                   props.snackbarShowMessage(
    //                     "You must select one default priority in External Tracking System Bugs settings",
    //                     "error",
    //                     3000
    //                   );
    //                   const updatedValue = {
    //                     BUGS: {
    //                       extDefaultSevErr:
    //                         "You must select one default priority in External Tracking System Bugs settings",
    //                     },
    //                   };
    //                   setErrMsg((errMsg) => ({
    //                     ...{},
    //                     ...updatedValue,
    //                   }));
    //                   return false;
    //                 }
    //               }
    //               if (
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_BUGS
    //                 ].type === TRACKING_SYSTEM_JIRA &&
    //                 !productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_BUGS
    //                 ].isToolConnected
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must connect to JIRA in External Tracking System Bugs settings",
    //                   "error",
    //                   3000
    //                 );
    //                 // const updatedValue = {
    //                 //   BUGS: {
    //                 //     extProjectTypeErr:
    //                 //     "You must connect to JIRA in External Tracking System Bugs settings",
    //                 //   },
    //                 // };
    //                 // setErrMsg((errMsg) => ({
    //                 //   ...{},
    //                 //   ...updatedValue,
    //                 // }));
    //                 return false;
    //               }
    //               if (
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_BUGS
    //                 ].type === TRACKING_SYSTEM_ZENDESK &&
    //                 !productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_BUGS
    //                 ].isToolConnected
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must connect to ZENDESK in External Tracking System Bugs settings",
    //                   "error",
    //                   3000
    //                 );
    //                 // const updatedValue = {
    //                 //   BUGS: {
    //                 //     extProjectTypeErr:
    //                 //     "You must connect to JIRA in External Tracking System Bugs settings",
    //                 //   },
    //                 // };
    //                 // setErrMsg((errMsg) => ({
    //                 //   ...{},
    //                 //   ...updatedValue,
    //                 // }));
    //                 return false;
    //               }
    //             }
    //           }
    //           if (
    //             productParams.products[0].trackingSystem &&
    //             productParams.products[0].trackingSystem.feedbackTypes.includes(
    //               FEEDBACK_TYPE_FEATURE_REQ
    //             )
    //           ) {
    //             if (
    //               productParams.products[0].trackingSystem &&
    //               productParams.products[0].trackingSystem.configs &&
    //               productParams.products[0].trackingSystem.configs[
    //                 FEEDBACK_TYPE_FEATURE_REQ
    //               ]
    //             ) {
    //               if (
    //                 productParams.products[0].trackingSystem &&
    //                 productParams.products[0].trackingSystem.configs &&
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEATURE_REQ
    //                 ].isToolConnected
    //               ) {
    //                 if (
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEATURE_REQ
    //                   ].isToolConnected &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEATURE_REQ
    //                   ].type === TRACKING_SYSTEM_JIRA
    //                 ) {
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEATURE_REQ
    //                       ].project
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one project type in External Tracking System Feature Request settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEATURE_REQUEST: {
    //                         extProjectTypeErr:
    //                           "You must select one project type in External Tracking System Feature Request settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEATURE_REQ
    //                       ].issueType
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one issue type in External Tracking System Feature Request settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEATURE_REQUEST: {
    //                         extIssueTypeErr:
    //                           "You must select one issue type in External Tracking System Feature Request settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEATURE_REQ
    //                       ].defaultSeverity
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one default priority type in External Tracking System Feature Request settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extDefaultSevErr:
    //                           "You must select one default priority type in External Tracking System Feature Request settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                 }
    //                 if (
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEATURE_REQ
    //                   ].isToolConnected &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEATURE_REQ
    //                   ].type === TRACKING_SYSTEM_ZENDESK
    //                 ) {
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEATURE_REQ
    //                       ].tags
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one tag type in External Tracking System Feature Request settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extProjectTypeErr:
    //                           "You must select one tag type in External Tracking System Feature Request settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEATURE_REQ
    //                       ].ticketType
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one ticket type in External Tracking System Feature Request settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extIssueTypeErr:
    //                           "You must select one ticket type in External Tracking System Feature Request settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEATURE_REQ
    //                       ].defaultSeverity
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one default priority type in External Tracking System Feature Request settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extDefaultSevErr:
    //                           "You must select one default priority type in External Tracking System Feature Request settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                 }
    //               }
    //               if (
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEATURE_REQ
    //                 ].type === TRACKING_SYSTEM_JIRA &&
    //                 !productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEATURE_REQ
    //                 ].isToolConnected
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must connect to JIRA in External Tracking System Feature Request settings",
    //                   "error",
    //                   3000
    //                 );
    //                 // const updatedValue = {
    //                 //   BUGS: {
    //                 //     extProjectTypeErr:
    //                 //     "You must connect to JIRA in External Tracking System Bugs settings",
    //                 //   },
    //                 // };
    //                 // setErrMsg((errMsg) => ({
    //                 //   ...{},
    //                 //   ...updatedValue,
    //                 // }));
    //                 return false;
    //               }
    //               if (
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEATURE_REQ
    //                 ].type === TRACKING_SYSTEM_ZENDESK &&
    //                 !productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEATURE_REQ
    //                 ].isToolConnected
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must connect to ZENDESK in External Tracking System Feature Request settings",
    //                   "error",
    //                   3000
    //                 );
    //                 // const updatedValue = {
    //                 //   BUGS: {
    //                 //     extProjectTypeErr:
    //                 //     "You must connect to JIRA in External Tracking System Bugs settings",
    //                 //   },
    //                 // };
    //                 // setErrMsg((errMsg) => ({
    //                 //   ...{},
    //                 //   ...updatedValue,
    //                 // }));
    //                 return false;
    //               }
    //             }
    //           }
    //           if (
    //             productParams.products[0].trackingSystem &&
    //             productParams.products[0].trackingSystem.feedbackTypes.includes(
    //               FEEDBACK_TYPE_FEEDBACK
    //             )
    //           ) {
    //             if (
    //               productParams.products[0].trackingSystem &&
    //               productParams.products[0].trackingSystem.configs &&
    //               productParams.products[0].trackingSystem &&
    //               productParams.products[0].trackingSystem.configs[
    //                 FEEDBACK_TYPE_FEEDBACK
    //               ]
    //             ) {
    //               if (
    //                 productParams.products[0].trackingSystem &&
    //                 productParams.products[0].trackingSystem.configs &&
    //                 productParams.products[0].trackingSystem &&
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEEDBACK
    //                 ].isToolConnected
    //               ) {
    //                 if (
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs &&
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEEDBACK
    //                   ].isToolConnected &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEEDBACK
    //                   ].type === TRACKING_SYSTEM_ZENDESK
    //                 ) {
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEEDBACK
    //                       ].tags
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one tag type in External Tracking System Feedback settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extProjectTypeErr:
    //                           "You must select one tag type in External Tracking System Feedback settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEEDBACK
    //                       ].ticketType
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one ticket type in External Tracking System Feedback settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extIssueTypeErr:
    //                           "You must select one ticket type in External Tracking System Feedback settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEEDBACK
    //                       ].defaultSeverity
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one default priority type in External Tracking System Feedback settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extDefaultSevErr:
    //                           "You must select one default priority type in External Tracking System Feedback settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                 }
    //                 if (
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs &&
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEEDBACK
    //                   ].isToolConnected &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEEDBACK
    //                   ].type === TRACKING_SYSTEM_JIRA
    //                 ) {
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEEDBACK
    //                       ].project
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one project type in External Tracking System Feedback settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extProjectTypeErr:
    //                           "You must select one project type in External Tracking System Feedback settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEEDBACK
    //                       ].issueType
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one issue type in External Tracking System Feedback settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extIssueTypeErr:
    //                           "You must select one issue type in External Tracking System Feedback settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                   if (
    //                     !(
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs &&
    //                       productParams.products[0].trackingSystem &&
    //                       productParams.products[0].trackingSystem.configs[
    //                         FEEDBACK_TYPE_FEEDBACK
    //                       ].defaultSeverity
    //                     )
    //                   ) {
    //                     props.snackbarShowMessage(
    //                       "You must select one default priority type in External Tracking System Feedback settings",
    //                       "error",
    //                       3000
    //                     );
    //                     const updatedValue = {
    //                       FEEDBACK: {
    //                         extDefaultSevErr:
    //                           "You must select one default priority type in External Tracking System Feedback settings",
    //                       },
    //                     };
    //                     setErrMsg((errMsg) => ({
    //                       ...{},
    //                       ...updatedValue,
    //                     }));
    //                     return false;
    //                   }
    //                 }
    //               }
    //               if (
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEEDBACK
    //                 ].type === TRACKING_SYSTEM_JIRA &&
    //                 !productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEEDBACK
    //                 ].isToolConnected
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must connect to JIRA in External Tracking System Feedback settings",
    //                   "error",
    //                   3000
    //                 );
    //                 // const updatedValue = {
    //                 //   BUGS: {
    //                 //     extProjectTypeErr:
    //                 //     "You must connect to JIRA in External Tracking System Bugs settings",
    //                 //   },
    //                 // };
    //                 // setErrMsg((errMsg) => ({
    //                 //   ...{},
    //                 //   ...updatedValue,
    //                 // }));
    //                 return false;
    //               }
    //               if (
    //                 productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEEDBACK
    //                 ].type === TRACKING_SYSTEM_ZENDESK &&
    //                 !productParams.products[0].trackingSystem.configs[
    //                   FEEDBACK_TYPE_FEEDBACK
    //                 ].isToolConnected
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must connect to ZENDESK in External Tracking System Feedback settings",
    //                   "error",
    //                   3000
    //                 );
    //                 // const updatedValue = {
    //                 //   BUGS: {
    //                 //     extProjectTypeErr:
    //                 //     "You must connect to JIRA in External Tracking System Bugs settings",
    //                 //   },
    //                 // };
    //                 // setErrMsg((errMsg) => ({
    //                 //   ...{},
    //                 //   ...updatedValue,
    //                 // }));
    //                 return false;
    //               }
    //             }
    //           }
    //         }
    //       }

    //       if (
    //         productParams &&
    //         productParams.products &&
    //         productParams.products[0] &&
    //         productParams.products[0].feedbackAgentSettings &&
    //         productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
    //       ) {
    //         if (
    //           !productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
    //             .text
    //         ) {
    //           props.snackbarShowMessage(
    //             "You must provide the text to be displayed on main button",
    //             "error",
    //             3000
    //           );
    //           const updatedValue = {
    //             widgetTextErr:
    //               "You must provide the text to be displayed on main button",
    //           };
    //           setErrMsg((errMsg) => ({
    //             ...{},
    //             ...updatedValue,
    //           }));
    //           return false;
    //         }
    //       }
    //       return true;
    //     }
    //     return false;
    //   }
    //   return false;
    // }

    // function featureSettingsMandatoryCheck(): boolean {
    //   if (productParams) {
    //     if (productParams.products[0].feedbackAgentSettings) {
    //       if (
    //         productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //           FEEDBACK_TYPE_FEATURE_REQ
    //         ) &&
    //         !productParams.products[0].feedbackAgentSettings.featureReqSettings
    //       ) {
    //         props.snackbarShowMessage(
    //           "You must specify feature request settings",
    //           "error",
    //           3000
    //         );
    //         const updatedValue = {
    //           featureReqSettingsErr: "You must specify feature request settings",
    //         };
    //         setErrMsg((errMsg) => ({
    //           ...{},
    //           ...updatedValue,
    //         }));
    //         return false;
    //       }

    //       if (
    //         productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //           FEEDBACK_TYPE_FEATURE_REQ
    //         ) &&
    //         productParams.products[0].feedbackAgentSettings.featureReqSettings
    //       ) {
    //         if (
    //           productParams &&
    //           productParams.products &&
    //           productParams.products[0] &&
    //           productParams.products[0].emailConfig &&
    //           productParams.products[0].emailConfig.feedbackTypes &&
    //           productParams.products[0].emailConfig.feedbackTypes.includes(
    //             FEEDBACK_TYPE_FEATURE_REQ
    //           )
    //         ) {
    //           if (
    //             !(
    //               productParams.products[0].emailConfig.emailSubject &&
    //               productParams.products[0].emailConfig.emailSubject[
    //                 FEEDBACK_TYPE_FEATURE_REQ
    //               ]
    //             )
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must provide email subject for feature request auto reply mail in Email settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               featureEmailSubErr: "You must provide email subject",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           if (
    //             !(
    //               productParams.products[0].emailConfig.emailText &&
    //               productParams.products[0].emailConfig.emailText[
    //                 FEEDBACK_TYPE_FEATURE_REQ
    //               ]
    //             )
    //           ) {
    //             props.snackbarShowMessage(
    //               "You must provide email body for feature request auto reply mail in Email settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               featureEmailBodyErr: "You must provide email body",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           if (
    //             productParams.products[0].emailConfig.emailText &&
    //             productParams.products[0].emailConfig.emailText[
    //               FEEDBACK_TYPE_FEATURE_REQ
    //             ]
    //           ) {
    //             const strippedVal = stripTags(
    //               productParams.products[0].emailConfig.emailText[
    //                 FEEDBACK_TYPE_FEATURE_REQ
    //               ]
    //             );
    //             if (!strippedVal) {
    //               props.snackbarShowMessage(
    //                 "You must provide email body for feature request auto reply mail in Email settings",
    //                 "error",
    //                 3000
    //               );
    //               const updatedValue = {
    //                 featureEmailBodyErr: "You must provide email body",
    //               };
    //               setErrMsg((errMsg) => ({
    //                 ...{},
    //                 ...updatedValue,
    //               }));
    //               return false;
    //             }
    //           }
    //         }
    //         if (
    //           productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
    //             FEEDBACK_TYPE_FEATURE_REQ
    //           ) &&
    //           productParams.products[0].feedbackAgentSettings.featureReqSettings
    //             .categories &&
    //           productParams.products[0].feedbackAgentSettings.featureReqSettings
    //             .categories.length > 0
    //         ) {
    //           const modifyCategories = [];
    //           let flag = false;
    //           const categories =
    //             productParams.products[0].feedbackAgentSettings.featureReqSettings
    //               .categories;
    //           for (const category of categories) {
    //             if (
    //               category["name"] == "" &&
    //               category["feedbacks"] &&
    //               category["feedbacks"]?.length != 0
    //             ) {
    //               flag = true;
    //             } else if (
    //               category["name"] == "" &&
    //               category["feedbacks"] &&
    //               category["feedbacks"]?.length == 0
    //             ) {
    //             } else {
    //               modifyCategories.push(category);
    //             }
    //           }
    //           if (flag) {
    //             props.snackbarShowMessage(
    //               "You must specify the category name for the feedback in feature request settings",
    //               "error",
    //               3000
    //             );
    //             const updatedValue = {
    //               featureCategoryErr:
    //                 "You must specify the category name for the feedback in feature request settings",
    //             };
    //             setErrMsg((errMsg) => ({
    //               ...{},
    //               ...updatedValue,
    //             }));
    //             return false;
    //           }
    //           productParams.products[0].feedbackAgentSettings.featureReqSettings.categories =
    //             modifyCategories;
    //         }
    //         if (
    //           (!productParams.products[0].feedbackAgentSettings.featureReqSettings
    //             .categories ||
    //             productParams.products[0].feedbackAgentSettings.featureReqSettings
    //               .categories.length < 1) &&
    //           productParams.products[0].feedbackAgentSettings.featureReqSettings
    //             .reqCategory
    //         ) {
    //           props.snackbarShowMessage(
    //             "You must specify at least one category in feature request settings",
    //             "error",
    //             3000
    //           );
    //           const updatedValue = {
    //             featureCategoryErr:
    //               "You must specify at least one category in feature request settings",
    //           };
    //           setErrMsg((errMsg) => ({
    //             ...{},
    //             ...updatedValue,
    //           }));
    //           return false;
    //         }
    //       }
    //     }
    //     if (productParams.products[0].trackingSystem) {
    //       if (
    //         productParams.products[0].trackingSystem &&
    //         productParams.products[0].trackingSystem.feedbackTypes
    //       ) {
    //         if (
    //           productParams.products[0].trackingSystem &&
    //           productParams.products[0].trackingSystem.feedbackTypes.includes(
    //             FEEDBACK_TYPE_FEATURE_REQ
    //           )
    //         ) {
    //           if (
    //             productParams.products[0].trackingSystem &&
    //             productParams.products[0].trackingSystem.configs &&
    //             productParams.products[0].trackingSystem.configs[
    //               FEEDBACK_TYPE_FEATURE_REQ
    //             ]
    //           ) {
    //             if (
    //               productParams.products[0].trackingSystem &&
    //               productParams.products[0].trackingSystem.configs &&
    //               productParams.products[0].trackingSystem.configs[
    //                 FEEDBACK_TYPE_FEATURE_REQ
    //               ].isToolConnected
    //             ) {
    //               if (
    //                 !(
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEATURE_REQ
    //                   ].project
    //                 )
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must select one project type in External Tracking System Feature Request settings",
    //                   "error",
    //                   3000
    //                 );
    //                 const updatedValue = {
    //                   FEATURE_REQUEST: {
    //                     extProjectTypeErr:
    //                       "You must select one project type in External Tracking System Feature Request settings",
    //                   },
    //                 };
    //                 setErrMsg((errMsg) => ({
    //                   ...{},
    //                   ...updatedValue,
    //                 }));
    //                 return false;
    //               }
    //               if (
    //                 !(
    //                   productParams.products[0].trackingSystem &&
    //                   productParams.products[0].trackingSystem.configs &&
    //                   productParams.products[0].trackingSystem.configs[
    //                     FEEDBACK_TYPE_FEATURE_REQ
    //                   ].issueType
    //                 )
    //               ) {
    //                 props.snackbarShowMessage(
    //                   "You must select one issue type in External Tracking System Feature Request settings",
    //                   "error",
    //                   3000
    //                 );
    //                 const updatedValue = {
    //                   FEATURE_REQUEST: {
    //                     extIssueTypeErr:
    //                       "You must select one issue type in External Tracking System Feature Request settings",
    //                   },
    //                 };
    //                 setErrMsg((errMsg) => ({
    //                   ...{},
    //                   ...updatedValue,
    //                 }));
    //                 return false;
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //     return true;
    //   }
    //   return false;
    // }

    // function trackingSystemMandatoryCheck(): boolean {
    //   return true;
    // }
    // function widgetSettingsMandatoryCheck(): boolean {
    //   if (
    //     productParams &&
    //     productParams.products &&
    //     productParams.products[0] &&
    //     productParams.products[0].feedbackAgentSettings &&
    //     productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
    //   ) {
    //     if (
    //       !productParams.products[0].feedbackAgentSettings.widgetLookAndFeel.text
    //     ) {
    //       props.snackbarShowMessage(
    //         "You must provide the text to be displayed on main button",
    //         "error",
    //         3000
    //       );
    //       const updatedValue = {
    //         widgetTextErr:
    //           "You must provide the text to be displayed on main button",
    //       };
    //       setErrMsg((errMsg) => ({
    //         ...{},
    //         ...updatedValue,
    //       }));
    //       return false;
    //     }
    //   }
    //   return true;
    // }

    // const handleChange = (event: any, newValue: number) => {
    //   setValue(newValue);
    // };

    // const HandleCancel = () => {
    //   navigate("/products");
    // };

    // const HandleSave = (e: any) => {
    //   const postData = productParams;
    //   if (
    //     basicSettingsMandatoryCheck() &&
    //     generalSettingsMandatoryCheck() &&
    //     feedbackSettingsMandatoryCheck() &&
    //     trackingSystemMandatoryCheck() &&
    //     bugSettingsMandatoryCheck() &&
    //     featureSettingsMandatoryCheck() &&
    //     widgetSettingsMandatoryCheck() &&
    //     changeEmailTags()
    //   ) {
    //     setIsLoading(true);
    //     if (
    //       productParams &&
    //       productParams.products &&
    //       productParams.products[0] &&
    //       productParams.products[0].id
    //     ) {
    //       if (products && products.productNameList.length > 0) {
    //         if (
    //           productParams.products[0].cloneNewVersion ||
    //           (location?.state?.version &&
    //             location?.state?.version != productParams.products[0].version)
    //         ) {
    //           const test = products.productNameList.filter(
    //             (e: any) => e.id == productParams.products[0].id
    //           );
    //           const test1 = test.filter(
    //             (e: any) => e.version == productParams.products[0].version
    //           );
    //           if (test1 && test1.length > 0) {
    //             props.snackbarShowMessage(
    //               "Version Already Exists! Please try some other version",
    //               "error"
    //             );
    //             setIsLoading(false);
    //           } else {
    //             if (
    //               postData &&
    //               postData.products &&
    //               postData.products[0] &&
    //               postData.products[0].cloneNewVersion
    //             ) {
    //               delete postData.products[0].cloneNewVersion;
    //             }
    //             Http.post({
    //               url: `/api/v2/products`,
    //               body: {
    //                 ...postData,
    //               },
    //               state: userInfo,
    //             })
    //               .then((response: any) => {
    //                 if (response) {
    //                   if (response.message === "Product already exists") {
    //                     props.snackbarShowMessage(
    //                       "product already exists",
    //                       "error",
    //                       3000
    //                     );
    //                   } else {
    //                     if (productParams) {
    //                       //Once create the product update product list api
    //                       getProductList();
    //                       const temp: IProductParams | undefined = {
    //                         ...productParams,
    //                       };
    //                       if (response.message && response.message.prodId) {
    //                         temp.products[0].id = response.message.prodId;
    //                         if (
    //                           temp.products[0].feedbackAgentSettings &&
    //                           temp.products[0].feedbackAgentSettings
    //                             .bannerImage &&
    //                           temp.products[0].feedbackAgentSettings
    //                             .bannerImage != ""
    //                         ) {
    //                           temp.products[0].feedbackAgentSettings.bannerImage =
    //                             response.message.bannerImage;
    //                         }
    //                       }
    //                       setWidgIntgSettingsAccordianContext(true);
    //                       // if (response.message && response.message.apiKey) {
    //                       //   temp.products[0].apiKey = response.message.apiKey;
    //                       // }
    //                       // if (response.message && response.message.apiKeyId) {
    //                       //   temp.products[0].apiKeyId = response.message.apiKeyId;
    //                       // }
    //                       //update the product in location so it consisder as update product instead of new clone version
    //                       navigate("", { state: temp[0] });
    //                       setProductParams(temp);
    //                       props.snackbarShowMessage(
    //                         "product created successfully",
    //                         "success",
    //                         3000
    //                       );
    //                       setTimeout(() => {
    //                         navigate("/products", {
    //                           state: "",
    //                         });
    //                       }, 2000);
    //                     }
    //                   }
    //                 }
    //                 setIsLoading(false);
    //               })
    //               .catch((error: any) => {
    //                 appLogger.error({
    //                   errObj: {
    //                     method: "HandleSave",
    //                     component: "add-products",
    //                     fileName: "index.tsx",
    //                     err: error,
    //                   },
    //                 });
    //                 setIsLoading(false);
    //                 props.snackbarShowMessage(error.message, "error");
    //               });
    //           }
    //           appLogger.info(
    //             {
    //               infoObj: {
    //                 method: "HandleSave",
    //                 component: "add-products",
    //                 fileName: "index.tsx",
    //                 oldVersion: location?.state?.version,
    //               },
    //             },
    //             "Old version"
    //           );
    //           appLogger.info(
    //             {
    //               infoObj: {
    //                 method: "HandleSave",
    //                 component: "add-products",
    //                 fileName: "index.tsx",
    //                 newVersion: productParams.products[0].version,
    //               },
    //             },
    //             "New version"
    //           );
    //         } else {
    //           if (
    //             postData &&
    //             postData.products &&
    //             postData.products[0] &&
    //             postData.products[0].cloneNewVersion
    //           ) {
    //             delete postData.products[0].cloneNewVersion;
    //           }
    //           putUpdate(postData);
    //         }
    //       }
    //     } else {
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "HandleSave",
    //             component: "add-products",
    //             fileName: "index.tsx",
    //             productParams: productParams,
    //           },
    //         },
    //         "New product"
    //       );
    //       if (
    //         postData &&
    //         postData.products[0] &&
    //         postData.products[0].technology == "rokuTv" &&
    //         postData.products[0].feedbackAgentSettings &&
    //         postData.products[0].feedbackAgentSettings.branding
    //       ) {
    //         const branding: brandingIF =
    //           postData.products[0].feedbackAgentSettings.branding;
    //         branding["branding-cuvo-editor-font-size"] = branding[
    //           "branding-cuvo-editor-font-size"
    //         ].replace("px", "");
    //         branding["branding-cuvo-input-label-font-size"] = branding[
    //           "branding-cuvo-input-label-font-size"
    //         ].replace("px", "");
    //         branding["branding-cuvo-comments-field-height"] = branding[
    //           "branding-cuvo-comments-field-height"
    //         ].replace("px", "");
    //         branding["branding-cuvo-popup-dialog-main-subtitle-font-size"] =
    //           branding[
    //             "branding-cuvo-popup-dialog-main-subtitle-font-size"
    //           ].replace("px", "");
    //         branding["branding-cuvo-popup-dialog-main-title-font-size"] =
    //           branding["branding-cuvo-popup-dialog-main-title-font-size"].replace(
    //             "px",
    //             ""
    //           );
    //         branding["branding-cuvo-primary-button-text-font-size"] = branding[
    //           "branding-cuvo-primary-button-text-font-size"
    //         ].replace("px", "");
    //         branding["branding-cuvo-secondary-button-text-font-size"] = branding[
    //           "branding-cuvo-secondary-button-text-font-size"
    //         ].replace("px", "");
    //         postData.products[0].feedbackAgentSettings.branding = branding;
    //       }
    //       //Set reqCategory to true if the flow is dynamic while saving the product
    //       if (
    //         postData &&
    //         postData.products[0] &&
    //         postData.products[0].feedbackAgentSettings &&
    //         postData.products[0].feedbackAgentSettings.feedbackSettings &&
    //         postData.products[0].feedbackAgentSettings.feedbackSettings.type ==
    //           FEEDBACK_FLOW_DYNAMIC
    //       ) {
    //         postData.products[0].feedbackAgentSettings.feedbackSettings.reqCategory =
    //           true;
    //       }
    //       Http.post({
    //         url: `/api/v2/products`,
    //         body: {
    //           ...postData,
    //         },
    //         state: userInfo,
    //       })
    //         .then((response: any) => {
    //           if (response) {
    //             if (response.message === "Product already exists") {
    //               props.snackbarShowMessage(
    //                 "product already exists",
    //                 "error",
    //                 3000
    //               );
    //             } else {
    //               if (productParams) {
    //                 //Once create the product update product list api
    //                 getProductList();
    //                 const temp: IProductParams | undefined = { ...productParams };
    //                 if (response.message && response.message.prodId) {
    //                   temp.products[0].id = response.message.prodId;
    //                   if (
    //                     temp.products[0].feedbackAgentSettings &&
    //                     temp.products[0].feedbackAgentSettings.bannerImage &&
    //                     temp.products[0].feedbackAgentSettings.bannerImage != ""
    //                   ) {
    //                     temp.products[0].feedbackAgentSettings.bannerImage =
    //                       response.message.bannerImage;
    //                   }
    //                 }
    //                 setWidgIntgSettingsAccordianContext(true);
    //                 // if (response.message && response.message.apiKey) {
    //                 //   temp.products[0].apiKey = response.message.apiKey;
    //                 // }
    //                 // if (response.message && response.message.apiKeyId) {
    //                 //   temp.products[0].apiKeyId = response.message.apiKeyId;
    //                 // }
    //                 //update the product in location so it consisder as update product instead of new clone version
    //                 navigate("", { state: temp[0] });
    //                 setProductParams(temp);
    //                 props.snackbarShowMessage(
    //                   "product created successfully",
    //                   "success",
    //                   3000
    //                 );
    //               }
    //             }
    //           }

    //           setIsLoading(false);
    //           // setTimeout(() => {
    //           //   if(e == "create") {
    //           //     navigate("/add-product", {
    //           //       state: "",
    //           //     })
    //           //   } else {
    //           //     navigate("/products", {
    //           //       state: "",
    //           //     })
    //           //   };
    //           // }, 2000);
    //         })
    //         .catch((error: any) => {
    //           appLogger.error({
    //             errObj: {
    //               method: "HandleSave",
    //               component: "add-products",
    //               fileName: "index.tsx",
    //               err: error,
    //             },
    //           });
    //           setIsLoading(false);
    //           props.snackbarShowMessage(error.message, "error");
    //         });
    //     }
    //   }
    // };

    // const putUpdate = (postData: any) => {
    //   appLogger.info(
    //     {
    //       infoObj: {
    //         method: "putUpdate",
    //         component: "add-products",
    //         fileName: "index.tsx",
    //         productParams: postData,
    //       },
    //     },
    //     "Update product"
    //   );
    //   Http.put({
    //     url: `/api/v2/products`,
    //     body: {
    //       ...postData,
    //     },
    //     state: userInfo,
    //   })
    //     .then((response: any) => {
    //       setIsLoading(false);
    //       if (response && response.message === "Product already exists") {
    //         props.snackbarShowMessage("Product already exists", "error", 3000);
    //       } else {
    //         props.snackbarShowMessage(
    //           "product saved successfully",
    //           "success",
    //           3000
    //         );
    //         setTimeout(() => {
    //           navigate("/products", {
    //             state: "",
    //           });
    //         }, 2000);
    //       }
    //     })
    //     .catch((error: any) => {
    //       appLogger.error({
    //         errObj: {
    //           method: "putUpdate",
    //           component: "add-products",
    //           fileName: "index.tsx",
    //           err: error,
    //         },
    //       });
    //       setIsLoading(false);
    //       props.snackbarShowMessage(error.message, "error");
    //     });
    // };
    // const [open, setOpen] = React.useState(false);

    // const handleClick = (id: any) => {
    //   setclickedItem(id);
    //   setOpen(true);
    // };

    // useEffect(() => {
    //   handleClick(1);
    // }, []);
    // useEffect(() => {
    //   getProductList();
    // }, []);
    // const getProductList = () => {
    //   Http.get({
    //     url: `/api/v2/products/0`,
    //     state: userInfo,
    //   })
    //     .then((response: any) => {
    //       appLogger.info({
    //         infoObj: {
    //           method: "getProductList",
    //           component: "add-products",
    //           fileName: "index.tsx",
    //           productListResponse: response,
    //         },
    //       });

    //       // const GroupedByBlock = [
    //       //   ...new Set(response?.productNameList?.map((item: any) => item.id)),
    //       // ];

    //       // const tempArray: any = [];

    //       // if (GroupedByBlock && GroupedByBlock.length) {
    //       //   GroupedByBlock.forEach((v, i) => {
    //       //     const newArray = response.productNameList.filter(function (
    //       //       el: any
    //       //     ) {
    //       //       return el.id == v;
    //       //     });

    //       //     const arrayObj = {
    //       //       name: newArray[0].name,
    //       //       fields: newArray,
    //       //     };
    //       //     tempArray.push(arrayObj);
    //       //   });
    //       // }

    //       setProducts(response);
    //       if (response && response.productNameList.length == 0) {
    //         openGuidedtour();
    //       }

    //       // const groupBy = (array: any, key: any) => {
    //       //   return array.reduce((result: any, currentValue: any, i: any) => {
    //       //     (result[currentValue.orgId] =
    //       //       result[currentValue.orgId] || []).push(currentValue);
    //       //     return result;
    //       //   }, []);
    //       // };
    //       // const groupedByProduct = groupBy(response.productNameList, "orgId");

    //       // setProducts(groupedByProduct);

    //       // setProducts(response.productNameList);
    //       setIsLoading(false);
    //     })
    //     .catch((error) => {
    //       appLogger.error({
    //         errObj: {
    //           method: "getProductList",
    //           component: "add-products",
    //           fileName: "index.tsx",
    //           err: error,
    //         },
    //       });
    //       setIsLoading(false);
    //     });
    // };

    // const handleClose = (id: any) => {
    //   setOpen(!open);
    //   setclickedItem("");
    // };

    // const renderIcon = (title: any) => {
    //   let icon: any = "";
    //   if (title == "agentpreview") {
    //     icon = (
    //       <Tooltip title="Agent Preview" placement="bottom">
    //         <Preview />
    //       </Tooltip>
    //     );
    //   } else if (title == "help") {
    //     icon = (
    //       <Tooltip title="Help" placement="bottom">
    //         <HelpIcon />
    //       </Tooltip>
    //     );
    //   }
    //   // else if (title == "preview") {
    //   //   icon = (
    //   //     <Tooltip title="Widget Preview" placement="bottom">
    //   //       <Preview />
    //   //     </Tooltip>
    //   //   );
    //   // }
    //   return icon;
    // };
    // const [scrollElement, setScrollElement] = useState("");
    // const [previewScrollElement, setpreviewScrollElement] = useState("");

    // const setScroll = (e: any) => {
    //   setScrollElement(e);
    // };
    // const setpreviewScroll = (e: any) => {
    //   setpreviewScrollElement(e);
    // };
    // // useEffect(() => {
    // //   prodFormScrollRef?.current?.scrollIntoView({ behavior: "smooth" });
    // //   setScroll("");
    // // }, [props]);
    // useEffect(() => {
    //   if (location && location.state && location.state.isGuideFromDashboard) {
    //     openGuidedtour();
    //   }
    // }, [location && location.state]);

    // const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    //   <Tooltip {...props} arrow classes={{ popper: className }} />
    // ))(({ theme }) => ({
    //   [`& .${tooltipClasses.arrow}`]: {
    //     color: "#0157ff",
    //   },
    //   [`& .${tooltipClasses.tooltip}`]: {
    //     // backgroundColor: theme.palette.common.black,
    //     backgroundColor: "#0157ff",
    //   },
    // }));
    // const handleJoyrideCallback = (data: any) => {
    //   const { action, index, status, type } = data;
    //   localStorage.setItem("setWalkthroughStepIndex", index);
    //   if (
    //     status == STATUS.FINISHED ||
    //     action == ACTIONS.CLOSE ||
    //     action == ACTIONS.SKIP
    //   ) {
    //     if (ACTIONS.SKIP == "skip") {
    //       setTooltipIsOpen(true);
    //       setTimeout(() => {
    //         setTooltipIsOpen(false);
    //       }, 3000);
    //     }
    //     setRun(false);
    //     localStorage.removeItem("setWalkthroughStepIndex");
    //   }
    // };

    // const openGuidedtour = () => {
    //   const getStep: any = localStorage.getItem("setWalkthroughStepIndex");
    //   let checkStepIndex: any = "";
    //   if (
    //     productParams &&
    //     productParams.products &&
    //     productParams.products[0] &&
    //     productParams.products[0].id
    //   ) {
    //     checkStepIndex = 3;
    //   } else {
    //     checkStepIndex = 5;
    //   }

    //   if (BasicDetailAccordianContext == false && getStep < checkStepIndex) {
    //     props.snackbarShowMessage(
    //       "Please open 'Basic Details' settings to start your walk through",
    //       "info",
    //       3000
    //     );
    //   } else {
    //     setRun(!run);
    //   }
    // };
    // const renderGuidedSteps = () => {
    //   let steps;
    //   if (location && location.state && location.state.cloneNewVersion) {
    //     // clone version steps
    //     steps = [
    //       {
    //         target: ".guideTourproductVersion",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Clone a version</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 1: Enter a version number for your product
    //             </h4>
    //           </div>
    //         ),
    //         disableBeacon: true,
    //       },
    //       {
    //         target: ".guideTourTechnology",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Clone a version</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 2: Select the technology in which your product was built.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourGeneralSettings",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Clone a version</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 3: Click on 'next' in each settings section to configure
    //               the behavior and look of the CuVo agent which will be a part of
    //               your product experience. These sections come with default
    //               configurations that you can modify at any time. Changes don’t
    //               require redeployment of the CuVo agent.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourViewActualSize",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Clone a version</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 4: You can preview your CuVo agent configuration in this
    //               section. Scroll up and down to view all the agent screens. Click
    //               this link to enlarge the preview in a new window
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourCreateSave",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Clone a version</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 5: Finally click the ‘save’ button to save your product’s
    //               configurations. The integration ‘steps’ section below will guide
    //               on how to integrate your CuVo agent into your product’s code.
    //               The steps may vary based on the technology and target device on
    //               your product.
    //             </h4>
    //           </div>
    //         ),
    //       },

    //       {
    //         target: ".guideTourHelpsection",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Help</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 6: Click on this icon here or on the heading of each of the
    //               configuration sections to get in-context help. For more details
    //               on creating and configuring your product, refer to the &nbsp;
    //               <a
    //                 className="guidefinalsteplink"
    //                 href="https://docs.cuvo.ai/manual/product/create"
    //                 target="_blank"
    //               >
    //                 ‘Create a product’
    //               </a>{" "}
    //               section in the user manual
    //             </h4>
    //           </div>
    //         ),
    //       },
    //     ];
    //   } else if (
    //     productParams &&
    //     productParams.products &&
    //     productParams.products[0] &&
    //     productParams.products[0].id
    //   ) {
    //     //edit form steps
    //     steps = [
    //       {
    //         target: ".guideTourproductName",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Edit a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 1: Modify the name for your product
    //             </h4>
    //           </div>
    //         ),
    //         disableBeacon: true,
    //       },
    //       {
    //         target: ".guideTourTechnology",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Edit a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 2: Change the technology in which your product is built.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourGeneralSettings",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Edit a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 3: Click on 'next' in each settings section to configure
    //               the behavior and look of the CuVo agent which will be a part of
    //               your product experience. These sections come with default
    //               configurations that you can modify at any time. Changes don’t
    //               require redeployment of the CuVo agent.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourViewActualSize",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Edit a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 4: You can preview your CuVo agent configuration in this
    //               section. Scroll up and down to view all the agent screens. Click
    //               this link to enlarge the preview in a new window
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourCreateSave",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Edit a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 5: Finally click the ‘save’ button to save your product’s
    //               configurations. The integration ‘steps’ section below will guide
    //               on how to integrate your CuVo agent into your product’s code.
    //               The steps may vary based on the technology and target device on
    //               your product.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourHelpsection",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Help</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 6: Click on this icon here or on the heading of each of the
    //               configuration sections to get in-context help. For more details
    //               on creating and configuring your product, refer to the &nbsp;
    //               <a
    //                 className="guidefinalsteplink"
    //                 href="https://docs.cuvo.ai/manual/product/create"
    //                 target="_blank"
    //               >
    //                 ‘Create a product’
    //               </a>{" "}
    //               section in the user manual
    //             </h4>
    //           </div>
    //         ),
    //       },
    //     ];
    //   } else {
    //     //add form steps
    //     steps = [
    //       {
    //         disableBeacon: true,
    //         target: ".guideTourproductName",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 1: Enter the name for your product.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourproductVersion",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 2: Enter a version number for your product.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".gudieTourPlatform",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 3: Select the target device for your product.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourTechnology",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 4: Select the technology in which your product is built.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourGeneralSettings",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 5: Click on 'next' in each settings section to configure
    //               the behavior and look of the CuVo agent which will be a part of
    //               your product experience. These sections come with default
    //               configurations that you can modify at any time. Changes don’t
    //               require redeployment of the CuVo agent.
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourViewActualSize",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 6: You can preview your CuVo agent configuration in this
    //               section. Scroll up and down to view all the agent screens. Click
    //               this link to enlarge the preview in a new window
    //             </h4>
    //           </div>
    //         ),
    //       },
    //       {
    //         target: ".guideTourCreateSave",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Create a product</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 7: Finally click the ‘create’ button to save your product’s
    //               configurations. The integration ‘steps’ section below will guide
    //               on how to integrate your CuVo agent into your product’s code.
    //               The steps may vary based on the technology and target device on
    //               your product.
    //             </h4>
    //           </div>
    //         ),
    //       },

    //       {
    //         target: ".guideTourHelpsection",
    //         content: (
    //           <div>
    //             <h3 className="guidesteptitle">Help</h3>
    //             <h4 className="guidestepsubtitle">
    //               Step 8: Click on this icon here or on the heading of each of the
    //               configuration sections to get in-context help. For more details
    //               on creating and configuring your product, refer to the &nbsp;
    //               <a
    //                 className="guidefinalsteplink"
    //                 href="https://docs.cuvo.ai/manual/product/create"
    //                 target="_blank"
    //               >
    //                 ‘Create a product’
    //               </a>{" "}
    //               section in the user manual
    //             </h4>
    //           </div>
    //         ),
    //       },
    //     ];
    //   }
    //   return steps;
    // };

    return (
      // <div
      //   className={isLoading ? "add-products-wrap loader" : "add-products-wrap"}
      // >
      //   <Joyride
      //     locale={{
      //       open: "Click to see the steps",
      //     }}
      //     run={run}
      //     callback={handleJoyrideCallback}
      //     disableScrolling
      //     styles={{
      //       options: {
      //         // modal arrow and background color
      //         arrowColor: "#0157ff",
      //         backgroundColor: "#0157ff",
      //         // page overlay color
      //         overlayColor: "#4f4f4f",
      //         //button color
      //         primaryColor: "#d68520",
      //         //text color
      //         textColor: "#fff",

      //         //width of modal
      //         width: 300,
      //         //zindex of modal
      //         zIndex: 1000,
      //       },
      //     }}
      //     continuous
      //     showProgress
      //     showSkipButton
      //     steps={renderGuidedSteps()}
      //   />
      //   <TabPanel value={value} index={0}>
      //     <Grid container spacing={2}>
      //       <Grid
      //         item
      //         xs={12}
      //         lg={6}
      //         className={`add-form-wrap ${open ? "show" : "hide"}`}
      //       >
      //         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      //           <Tabs value={value} onChange={handleChange} aria-label="tabs">
      //             <Tab
      //               label={
      //                 productParams &&
      //                 productParams.products &&
      //                 productParams.products[0] &&
      //                 productParams.products[0].id
      //                   ? "edit product"
      //                   : "add new product"
      //               }
      //               {...a11yProps(0)}
      //             />

      //             <Button
      //               type="button"
      //               variant="outlined"
      //               sx={{ textTransform: "uppercase" }}
      //               onClick={HandleCancel}
      //               className="create-pro-btn "
      //               id="pro-cancel"
      //             >
      //               close
      //             </Button>

      //             <Button
      //               type="submit"
      //               variant="contained"
      //               sx={{ textTransform: "uppercase" }}
      //               onClick={HandleSave}
      //               className="create-pro-btn guideTourCreateSave"
      //               id="pro-save"
      //             >
      //               {productParams &&
      //               productParams.products &&
      //               productParams.products[0] &&
      //               productParams.products[0].id
      //                 ? "save"
      //                 : "create"}
      //             </Button>
      //           </Tabs>
      //         </Box>

      //         <ProductsForm
      //           setWidgetActionValue={setWidgetActionValue}
      //           setProductParams={setProductParams}
      //           productParams={productParams}
      //           errMsg={errMsg}
      //           setErrMsg={setErrMsg}
      //           setScroll={setScroll}
      //           setpreviewScroll={setpreviewScroll}
      //           sethandleClick={handleClick}
      //           getVersionFromEditForm={location?.state?.version}
      //           saveProduct={HandleSave}
      //           basicSettingsMandatoryCheck={basicSettingsMandatoryCheck}
      //           generalSettingsMandatoryCheck={generalSettingsMandatoryCheck}
      //           feedbackSettingsMandatoryCheck={feedbackSettingsMandatoryCheck}
      //           bugSettingsMandatoryCheck={bugSettingsMandatoryCheck}
      //           featureSettingsMandatoryCheck={featureSettingsMandatoryCheck}
      //           widgetSettingsMandatoryCheck={widgetSettingsMandatoryCheck}
      //           enabledFeatures={enabledFeatures}
      //         />
      //       </Grid>
      //       {open && (
      //         <Grid item xs={12} lg={6} className="faq-wrap">
      //           <List component="div" disablePadding sx={{ position: "unset" }}>
      //             <FAQ
      //               widgetAppearance={widgetActionValue}
      //               contentType={clickedItem}
      //               handleClose={handleClose}
      //               scrollElement={scrollElement}
      //               setScroll={setScroll}
      //               setpreviewScroll={setpreviewScroll}
      //               previewScrollElement={previewScrollElement}
      //               productParams={productParams}
      //             />
      //           </List>
      //         </Grid>
      //       )}
      //       <div className="help-area-list-icon">
      //         <List
      //           sx={{
      //             display: "flex",
      //             flexDirection: "column",
      //             flexWrap: "wrap",
      //           }}
      //         >
      //           {items.map(function (item: any) {
      //             return (
      //               <ListItem
      //                 onClick={() => handleClick(item.id)}
      //                 className={
      //                   clickedItem === item.id
      //                     ? "listItemClicked help-list" +
      //                       `${
      //                         item.title == "help" ? " guideTourHelpsection" : ""
      //                       }`
      //                     : "listItemNotClicked help-list" +
      //                       `${
      //                         item.title == "help" ? " guideTourHelpsection" : ""
      //                       }`
      //                 }
      //                 key={item.id}
      //               >
      //                 {renderIcon(item.title)}
      //               </ListItem>
      //             );
      //           })}
      //         </List>
      //       </div>
      //     </Grid>{" "}
      //     <>
      //       {/* <BootstrapTooltip
      //           open={tooltipIsOpen}
      //           onOpen={() => setTooltipIsOpen(true)}
      //           onClose={() => setTooltipIsOpen(false)}
      //           title="You can walk through at any time!"
      //         > */}
      //       <Button
      //         variant="contained"
      //         onClick={() => openGuidedtour()}
      //         className="walkthrough-btn"
      //       >
      //         <img src={images.walkthrough} /> &nbsp; Walk Through
      //         {/* animate-charcter */}
      //       </Button>
      //       {/* </BootstrapTooltip> */}
      //     </>
      //   </TabPanel>
      // </div>

      <div>old code please delete</div>
    );
  };
export default AddProducts;

// export default withSnackbar(AddProducts);
